<template>
  <main>
    <transition name="fade" mode="out-in">
      <router-view></router-view>
    </transition>
    <div class="fixed-mask" v-if="isMobile">
      <div class="mobile-tips">
        <div class="tip-title">Coming soon……</div>
        <div class="tip-contant">
          To date, The Super Solar Calculator is only available on PC. The
          mobile version is yet to come. Please stay tuned!
        </div>
        <button @click="goToRenogyHome" class="mobile-btn">Got It</button>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  data() {
    return {
      isMobile: false
    };
  },
  created() {
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    );
    if (isMobile) {
      this.isMobile = true;
    }
    // console.log(isMobile);
  },
  methods: {
    goToRenogyHome() {
      if (window.parent) {
        window.parent.location.href = "https://www.renogy.com/";
      } else {
        window.location.href = "https://www.renogy.com/";
      }
    }
  }
};
</script>

<style lang="scss" type="text/css">
@import "./assets/css/font/font.css";
body {
  font-family: MontserratRegular;
  min-width: 1200px;
}
</style>
<style lang="scss">
.fixed-mask {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 100;
  background: rgba(0, 0, 0, 0.64);
  .mobile-tips {
    color: white;
    padding: 20px;
    border-radius: 8px;
    background-color: #272d3a;
    width: 90%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
    .tip-title {
      width: 100%;
      text-align: center;
      font-weight: 600;
      font-size: 20px;
    }
    .tip-contant {
      font-weight: 400;
      font-size: 14px;
      margin-top: 20px;
      line-height: 1.7;
    }
    .mobile-btn {
      width: 100%;
      color: #000;
      border: none;
      border-radius: 8px;
      text-align: center;
      height: 40px;
      line-height: 40px;
      font-size: 16px;
      font-weight: 500;
      margin-top: 20px;
      background-color: #56ccf2;
    }
  }
}
.ivu-message-notice-content {
  background: rgba(0, 0, 0, 0.8) !important;
  color: #fff;
}
.ivu-message {
  top: 50% !important;
}
.ivu-message .ivu-icon {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/App.vue